module.exports = __webpack_public_path__ + "img/telegram.acd49a47.png";